import { render, staticRenderFns } from "./detail-approve.vue?vue&type=template&id=183a22f8"
import script from "./detail-approve.vue?vue&type=script&lang=js"
export * from "./detail-approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports